import { useEffect } from "preact/hooks";
import { get } from "../../utils/http";

export const CometChat = () => {
	const regID = window.dataLayer[0]["Registrant ID"]
	const fullName = window.dataLayer[0]["First & Last Name"]
	var company = window.dataLayer[0]['Company (Subsidiary)'];
	var userName = `${fullName}`
	const picture = window.dataLayer[0]['Please make it more personal by uploading a head and shoulders photo:'] || "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Linecons_user-avatar.svg/600px-Linecons_user-avatar.svg.png"
	const regUid = regID.toString()

	useEffect(() => {
		window.openDM = chatGuid => {
			window.CometChatWidget.openOrCloseChat(true)
			window.CometChatWidget.chatWithUser(chatGuid);
		}
	})

	const loadStage4 = () => {
		window.CometChatWidget.launch({
			alignment: "right",
			docked: "true",
			height: "550px",
			// left or right
			roundedCorners: "true",
			widgetID: "6cfac693-5632-4cde-8475-93cc3736ebb1",
			width: "400px",
		})
		if (window.dataLayer[0]["Registrant Type"] === "Non-Member") {
			get(`https://isf2021.swoogo-retrofit.tkevents.io/chat/addToNonMemberChats`, { id: regUid })
		} else {
			get(`https://isf2021.swoogo-retrofit.tkevents.io/chat/addToMemberChats`, { id: regUid })
		}
	}

	const loadStage3 = () => {
		// You can now call login function.
		window.CometChatWidget.login({
			uid: regUid,
		}).then(loadStage4)
	}

	const loadStage2 = () => {
		window.CometChatWidget.createOrUpdateUser({
			avatar: picture,
			name: userName,
			uid: regUid,
		}).then(loadStage3)
	}

	const loadStage1 = () => {
		window.CometChatWidget.init({
			widgetID: "edc922f5-80ef-4192-8bbc-4dd4d3ec9816",
			appID: "276150de9e45a827",
			appRegion: "eu",
			authKey: "77b84cec1d970a042158ea35d7d676623900fecf",
		}).then(loadStage2)
	}

	const bootChatIfReady = () => {
		if (window.CometChatWidget === undefined) {
			setTimeout(bootChatIfReady, 250)
		} else { loadStage1() }
	}

	bootChatIfReady()

	return <script defer src="https://widget-js.cometchat.io/v3/cometchatwidget.js" />
}

window.openChat = chatGuid => {
	window.CometChatWidget.openOrCloseChat(true)
	window.CometChatWidget.chatWithGroup(chatGuid);
}